import c from '../colors';
import { setAlpha } from '../utils';

/**
 * Temporary doc until the new Design System site is up
 * @see https://gitlab.sas.com/novacommons/nova-tokens/-/tree/master/tokens
 */
export const stateInputNova = {
  normal(theme) {
    return {
      fg: c.colorTextDefault(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorNeutral(theme)
    };
  },
  hover(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          fg: c.colorTextDefault(theme),
          bg: c.colorUiLight(theme),
          bd: c.colorNeutral(theme)
        };
      default:
        return {
          fg: c.colorTextLabel(theme),
          bg: c.colorUiLight(theme),
          bd: c.colorNeutral(theme)
        };
    }
  },
  active(theme) {
    return {
      fg: c.colorTextDefault(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorPrimary(theme)
    };
  },
  focused(theme) {
    return stateInputNova.active(theme);
  },
  disabled(theme) {
    return {
      fg: setAlpha(c.colorTextDefault(theme), 0.32),
      bg: c.colorUiLight(theme),
      bd: setAlpha(c.colorNeutral(theme), 0.32)
    };
  },
  readOnly(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          fg: c.colorTextDefault(theme),
          bg: c.colorUiLight(theme),
          bd: c.colorUiLight(theme)
        };
      default:
        return {
          fg: c.colorTextDefault(theme),
          bg: 'transparent',
          bd: 'transparent'
        };
    }
  },
  nonEditable(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
      case 'dark':
        return {
          fg: c.colorTextDefault(theme),
          bg: setAlpha(c.colorNeutral(theme), 0.16),
          bd: 'transparent'
        };
      default:
        return {
          fg: c.colorTextDefault(theme),
          bg: setAlpha(c.colorNeutral(theme), 0.08),
          bd: 'transparent'
        };
    }
  }
};
//# sourceMappingURL=input-states.js.map